import React from 'react';
import PageLayout from '../../components/layout/PageLayout';
import { useTheme } from '../../context/ThemeContext';
import { CheckIcon } from '../../components/Icons/svgIcons';

const themes = [
  {
    id: 'default',
    name: 'Terriqon Default',
    description: 'Blue Header, Green/Purple Actions',
    colors: { header: '#005A9C', primary: '#2e7d32', secondary: '#005A9C' }
  },
  {
    id: 'professional',
    name: 'Professional',
    description: 'Slate Header, Green/Purple Actions',
    colors: { header: '#334155', primary: '#2e7d32', secondary: '#005A9C' }
  },
  {
    id: 'ocean',
    name: 'Ocean Blue',
    description: 'Blue Header, Blue Actions',
    colors: { header: '#005A9C', primary: '#0284c7', secondary: '#0ea5e9' }
  },
  {
    id: 'royal',
    name: 'Royal',
    description: 'Slate Header, Purple Actions',
    colors: { header: '#334155', primary: '#6b21a8', secondary: '#7e22ce' }
  }
];

const ThemePage = () => {
  const { currentTheme, changeTheme, resetTheme } = useTheme();

  return (
    <PageLayout title="App Appearance" showBackButton showStatus>
      <div className="space-y-6">
        <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
          <div className="px-6 py-4 border-b border-gray-200 bg-gray-50/30">
            <h3 className="text-lg font-bold text-gray-900">Theme Selection</h3>
            <p className="text-sm text-gray-500 mt-1">Select a theme that suits your preference.</p>
          </div>
          
          <div className="p-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {themes.map((theme) => {
              const isActive = currentTheme === theme.id;
              return (
                <button
                  key={theme.id}
                  onClick={() => changeTheme(theme.id)}
                  className={`relative flex flex-col p-4 rounded-xl border-2 text-left transition-all duration-200 ${
                    isActive 
                      ? 'border-[var(--btn-primary-bg)] bg-[var(--btn-primary-bg)]/5 ring-1 ring-[var(--btn-primary-bg)]/20' 
                      : 'border-transparent bg-gray-50 hover:bg-gray-100 hover:border-gray-200'
                  }`}
                >
                  <div className="flex items-center gap-3 mb-3">
                    <div className="flex -space-x-2">
                      <div className="w-8 h-8 rounded-full border-2 border-white shadow-sm" style={{ backgroundColor: theme.colors.header }} title="Header" />
                      <div className="w-8 h-8 rounded-full border-2 border-white shadow-sm" style={{ backgroundColor: theme.colors.primary }} title="Primary Action" />
                      <div className="w-8 h-8 rounded-full border-2 border-white shadow-sm" style={{ backgroundColor: theme.colors.secondary }} title="Secondary Action" />
                    </div>
                    {isActive && (
                      <div className="ml-auto w-6 h-6 rounded-full bg-[var(--btn-primary-bg)] flex items-center justify-center shadow-sm">
                        <CheckIcon className="w-3.5 h-3.5 text-white" />
                      </div>
                    )}
                  </div>
                  
                  <h4 className={`font-bold text-sm ${isActive ? 'text-[var(--btn-primary-bg)]' : 'text-gray-900'}`}>
                    {theme.name}
                  </h4>
                  <p className="text-xs text-gray-500 mt-1 font-medium">{theme.description}</p>
                </button>
              );
            })}
          </div>
        </div>

        <button
          onClick={resetTheme}
          className="w-full py-4 rounded-xl border-2 border-dashed border-gray-300 text-gray-500 font-semibold text-sm hover:bg-gray-50 hover:border-gray-400 hover:text-gray-700 transition-all active:scale-[0.99]"
        >
          Reset to Default Theme
        </button>
      </div>
    </PageLayout>
  );
};

export default ThemePage;